/*
# -----------------------------------------------------------------------------
# Component: receiptsViewMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 27/May/2019
# Comments: Responsible for receipt entry and review functionality
# -----------------------------------------------------------------------------
*/
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime4 } from '@/utils/date'

export const receiptsViewMixin = {
  data() {
    return {
      receiptsForm: {
        branch: null,
        accountNo: null,
        documentNo: null,
        docAE: true,
        documentNoDisabled: null,
        transactionType: null,
        fund: null,
        accountNoSuffix: '',
        accountNoSuffixDesc: '',
        transactionDate: new Date(),
        transactionDateDisp: new Date(),
        receivedFrom: null,
        depositAcct: null,
        bankNo: null,
        paymentMethod: null,
        cashBook: null,
        gstIO: null,
        gstStatus: null,
        gstRate: this.defaultAmount(),
        currency: null,
        amount: this.defaultAmount(),
        gstAmount: this.defaultAmount(),
        gstAmountAE: null,
        netAmount: this.defaultAmount(),
        bankAmount: this.defaultAmount(),
        bankAmountAE: null,
        bankCharges: this.defaultAmount(),
        bankTotalAmount: this.defaultAmount(),
        bankTotalLocal: this.defaultAmount(),
        bankTotalLocalAE: null,
        amountCurr: null,
        gstAmountCurr: null,
        netAmountCurr: null,
        bankAmountCurr: null,
        bankChargesCurr: null,
        bankTotalAmountCurr: null,
        bankTotalLocalCurr: null,
        printDocument: null, // Optional Fields -- Start
        addressTo: null,
        policyNo: null,
        companyName: null,
        docAddress1: null,
        docAddress2: null,
        docAddress3: null,
        docAddress4: null,
        postalCode: null,
        details: null,
        statementRef: null,
        department: null,
        insuredName: null,
        claimNo: null,
        gstRegNo: null,
        taxInvoiceNo: null, // Optional Fields -- End
        payerBank: null, // Payment Method Fields -- Start
        payersChequeNo: null,
        drawerName: null,
        creditCardNo: null, // Payment Method Fields -- End
        amountCurrRate: null,
        bankAmountCurrRate: null,
        actionName: null,
        bankTotalLocalCurrRate: this.defaultAmount(),
        oldFund: null,
        oldAccountNoSuffix: null,
        isExistDocNo: null,
        insdRefNo: null,
        bmBrn: null,
        bmTranType: null,
        bmDocNo: null,
        bmFund: null,
        bmAcctNoSfx: null,
        bmAcctNo: null,
        cnNo: null,
        vehRegNo: null,
        bchMch: false,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      receiptsFormLabel: {
        branch: 'Branch*',
        accountNo: 'Account No',
        documentNo: 'Document No',
        docAE: 'Auto Receipt No.',
        transactionType: 'Transaction Type',
        fund: 'Fund*',
        accountNoSuffixDesc: 'Suffix',
        transactionDateDisp: 'Transaction Date*',
        receivedFrom: 'Received From*',
        depositAcct: 'Deposit Account*',
        paymentMethod: 'Payment Method*',
        cashBook: 'Cash Book',
        gstIO: 'GST IO*',
        gstStatus: 'Status*',
        gstRate: 'Rate*',
        currency: 'Currency',
        amount: 'Amount*',
        gstAmount: 'GST Amount',
        netAmount: 'Net Amount',
        bankAmount: 'Bank Amount',
        bankCharges: 'Bank Charges',
        bankTotalAmount: 'Bank Total Amount',
        bankTotalLocal: 'Bank Total Local',
        amountCurr: 'Amount Currency*',
        gstAmountCurr: 'GST Amount Currency',
        netAmountCurr: 'Net Amount Currency',
        bankAmountCurr: 'Bank Amount Currency',
        bankChargesCurr: 'Bank Charges Currency',
        bankTotalAmountCurr: 'Bank Total Amount Currency',
        bankTotalLocalCurr: 'Bank Total Local Currency',
        printDocument: 'Print Document',
        addressTo: 'Address To',
        policyNo: 'Policy No',
        companyName: 'Name',
        docAddress1: 'Address 1',
        docAddress2: 'Address 2',
        docAddress3: 'Address 3',
        docAddress4: 'Address 4',
        postalCode: 'Postal Code',
        details: 'Details',
        statementRef: 'Statement Reference',
        department: 'Department',
        insuredName: 'Insured Name',
        claimNo: 'Claim No',
        gstRegNo: 'GST Reg No',
        taxInvoiceNo: 'Their Tax Invoice No',
        payerBank: 'Payer Bank',
        payersChequeNo: 'Cheque No',
        drawerName: 'Drawer Name',
        creditCardNo: 'Credit Card No',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      gstIOOptions: [
        { value: 'B', label: '' },
        { value: 'I', label: 'I - Input' },
        { value: 'O', label: 'O - Output' }
      ],
      printDocOptions: [
        { value: 'I', label: 'I - Immediately' },
        { value: 'L', label: 'L - Later' },
        { value: 'N', label: 'N - No' }
      ],
      addressToOptions: [
        { value: 'A', label: 'A - Agent' },
        { value: 'I', label: 'I - Insured' },
        { value: 'E', label: 'E - Entered as below' }
      ],
      nowDT: formatDisplayDateTime4(new Date()),
      createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
